// Product image zoom/unzoom (prevent cart or menu button from being clicked when zoomed in on an image)
$('.pswp__button--close').on('pswpTap', function (event) {
    event.stopPropagation()
})

// videos

$(document).ready(function() {
    var videos = $("video");
    videos.each( function() {
        var video = $(this).get(0)
        if(video.autoplay) {
            $(this).attr('playsinline', '')
            video.play()
        } else {
            $(this).after('<div class="play-button"><span></span></div>')
            $(this).prop('muted', true)
            $(this).prop('loop', true)
            video.play() 
        }
    })

    var vimeo_videos = $('.vimeo-video-block.controls')
    if(vimeo_videos.length > 0) {
        vimeo_videos.each( function() {
            $(this).append('<div class="play-button"><span></span></div>')
    
            var play_button = $(this).find('.play-button')
    
            var iframe = $(this).find('iframe')[0];
    
            var player = new Vimeo.Player(iframe);
            player.on('finish', function() {
                play_button.show()
            });
        })
    }

    $('video').on("ended", function() {
        $(this).siblings('.play-button').show()
        $(this).prop('muted', true)
    });

    //vimeo-video-block
    vimeo_background_videos()
});

$( window ).resize(function() {
    vimeo_background_videos()
});

function downloadURI(uri) {
    var link = document.createElement("a");
    link.href = uri;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    link.remove();
}

$(document).on('click', '.play-button', function() {
    if( $(this).parent().hasClass('vimeo-video-block') ) {
        var iframe = $(this).parent().find('iframe')
        var iframeUrl = iframe.attr('src');
        var pattern = /(\?|&)muted=1(&|$)/;
        if( pattern.test(iframeUrl)) {
            var newUrl = iframeUrl.replace(pattern, '$1muted=0$2');
            iframe.attr('src', newUrl);
            var player = new Vimeo.Player(iframe);
            player.loadVideo(newUrl);
        } else {
            iframe[0].contentWindow.postMessage(JSON.stringify({
                'method': 'play'
              }), '*');
        }
        $(this).hide()
    } else {
        $(this).siblings('video').prop('muted', false)
        $(this).siblings('video').get(0).play()
        $(this).hide()
    }
})

$(document).on( 'click', "video ", function() {
    if( $(this).parents('.vimeo-video-block').length < 1 ) {
        var video = $(this).get(0);

        if ( video.paused ) {
            video.play();
            $(this).prop('muted', false)
            $(this).siblings('.play-button').hide()
        } else {
            $(this).prop('muted', true)
            $(this).siblings('.play-button').show()
        }
        return false;
    }
});

$(document).on('click', '.vimeo-video-block.controls', function(e) {
    var clickedElement = e.target;
    var isPlayButton = $(clickedElement).is('.play-button');
    var isPlayButtonChild = $(clickedElement).closest('.play-button').length > 0;

    if( !isPlayButton && !isPlayButtonChild ) { 
        var iframe = $(this).find('iframe')
        var iframeUrl = iframe.attr('src');
        var autoplay = /(\?|&)autoplay=1(&|$)/;
        var muted = /(\?|&)muted=1(&|$)/;
        var loop = /(\?|&)loop=1(&|$)/;
        if( !muted.test(iframeUrl) && autoplay.test(iframeUrl) && loop.test(iframeUrl) ) {
            var pattern = /(\?|&)muted=0(&|$)/;
            var newUrl = iframeUrl.replace(pattern, '$1muted=1$2');
            iframe.attr('src', newUrl);
            var player = new Vimeo.Player(iframe);
            player.loadVideo(newUrl);
            iframe[0].contentWindow.postMessage(JSON.stringify({
                'method': 'pause'
              }), '*');
        } else {
            iframe[0].contentWindow.postMessage(JSON.stringify({
                'method': 'pause'
              }), '*');
        }
        $(this).find('.play-button').show()

    }
})

//vimeo-video-block
function vimeo_background_videos() {
    $('.vimeo-video-block.background, .vimeo-video-block.square').each( function() {
        var block_ratio = $(this).width() / $(this).height()
        var video_ratio = $(this).attr('ratio')
        if( block_ratio < video_ratio ) {
            $(this).removeClass('height-over')
            $(this).addClass('width-over')
            $(this).find('iframe').show()
        } else {
            $(this).removeClass('width-over')
            $(this).addClass('height-over')
            $(this).find('iframe').show()
        }
    })
}

$(document).on('click', '.play-video', function() {
    var closest_video = ''
    var element = $(this)
    while( closest_video == '' || element.get(0) === document.body ) {
        if( element.parent().find('.vimeo-video-block').length > 0 ) {
            closest_video = element.parent().find('.vimeo-video-block')
        } else {
            element = element.parent()
        }    
    }
    if( closest_video !== '' ) {
        closest_video.find('.play-button').click()
    }
})

// staff-block
$(document).on('click', '.staff-block .open-info', function() {
    var content = $(this).siblings('.info-content')
    if(content.is(':visible')) {
        $(this).parent().removeClass('open')
    } else {
        $(this).parent().addClass('open')
    }
    content.slideToggle()
})

// products block
$(document).on('click', '.products-block .open-service-content', function() {
    var content = $(this).parent().siblings('.service-content')
    if(content.is(':visible')) {
        content.slideToggle('400', function() {
            $(this).closest('.product').css('height', 'auto')
            $(this).closest('.content-wrapper').removeClass('open')
        })
    } else {
        $(this).closest('.content-wrapper').addClass('open')
        var height = $(this).closest('.product').height()
        $(this).closest('.product').css('height', height)
        content.slideToggle()
    }
})

// anchor
$(document).ready( function() {
    if(window.location.hash){
        var $target  = $(window.location.hash)
        var header_height = $('header').height()
        if($target.length > 0) {
            $('html, body').animate({scrollTop: $target.offset().top - header_height } , 400);
        }
    }

    $(document).on('click', 'a[href*="#"]', function(e) {
        var href = $(this).attr("href");
        if( href.startsWith("#") || href.startsWith(window.location.href + "#") ) {
            e.preventDefault();
            var target = href.split("#")[1]
            if( target == 'scroll-to-page-top') {
                //scroll-to-page-top
                $('html, body').animate({scrollTop: $('html, body').offset().top } , 1000);
            } else {
                if( $('#' + target).length > 0 ) {
                    var header_height = $('header').height()
                    $('html, body').animate({scrollTop: $('#' + target).offset().top - header_height } , 400);
                }
            }
        }
    })
})